<div class="error-template-wrapper">
    <img class="error-image" *ngIf="error.icon != '' " [src]="error.icon"/>
    <div class="error-text">{{error.description}}</div>
</div>